export default "__VITE_ASSET__CfJGlVdF__"